export default "__VITE_PUBLIC_ASSET__f215e050__"